import { render, staticRenderFns } from "./MoleculeListResource.vue?vue&type=template&id=33aada45&scoped=true&"
import script from "./MoleculeListResource.vue?vue&type=script&lang=js&"
export * from "./MoleculeListResource.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeListResource.vue?vue&type=style&index=0&id=33aada45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aada45",
  null
  
)

export default component.exports